import { InjectionToken } from '@angular/core';

export interface SharedApiConfig {
  apiBaseUrl: string;
  endpoints: {
    login: string;
    validateToken: string;
    sendRecoveryCode: string;
    changePassword: string;
    verifyPassword: string;
  };
}

export const SHARED_API_CONFIG = new InjectionToken<SharedApiConfig>('shared.api.config');
